export default __webpack_public_path__ + "static/media/background.7055a1ee.jpg";